import $ from 'jquery';

/**
 * Masterpass v1 (MFS) SDK'sının istek biçimi.
 *
 * ⚠️ v1 JSON KABUL ETMEZ. Alanları DOM'da gizli bir `<form>` içine `<input>`
 * olarak yazıp form elemanını SDK'ya vermek gerekir; SDK değerleri oradan okur.
 * jQuery bağımlılığı da buradan gelir. v2 SDK'sı bunun yerine düz JSON alır,
 * bu yüzden dosya yalnızca v1 adaptöründen kullanılır.
 */

const parseFormData = (jsonData: any, formId: string) => {
  const htmlString = `
    <form action="" method="POST" id="${formId}" class="form-horizontal">
        ${Object.keys(jsonData)
          .map((key) => `<input type="hidden" name="${key}" value="${jsonData[key]}" />`)
          .join('')}
       
    </form>`;

  const dom = document.createElement('div');
  dom.innerHTML = htmlString;
  return $(dom).find(`#${formId}`);
};

export default parseFormData;
